import { cn } from "@/libs/utils";
import { useResponsive } from "@/contexts/ResponsiveProvider";
import React from "react";
import InfoIcon from "@/v2-components/core/icon/info-icon";

export const SoftwareMainContents = ({
  info, //text script
  className,
}: {
  info: { head: React.ReactNode; body: string; caution?: string };
  className?: string;
}) => {
  const { head, body, caution } = info;
  return (
    <div className="flex h-full flex-col">
      <article
        className={cn(
          "relative z-10 mx-auto flex h-full w-full text-white",
          className,
        )}
      >
        <div className="mx-auto flex w-full max-w-[1440px] flex-col sm:justify-center">
          <h1 className="pb-4 text-[22px] font-400 leading-[44px] md:mb-[16px] md:text-[57px]">
            {head}
          </h1>
          <p className="whitespace-pre-wrap text-[14px] font-400 leading-[22px] sm:max-w-[500px]">
            {body}
          </p>
        </div>
      </article>
      {!!caution && <Caution caution={caution} />}
    </div>
  );
};

function Caution({ caution }: { caution: string }) {
  const { isTablet } = useResponsive();
  return (
    <div
      className={cn(
        "z-10 mx-auto flex w-full max-w-[1440px] items-center gap-x-1 pt-4 sm:gap-x-[6px] md:pb-10",
      )}
    >
      <InfoIcon
        className={cn(
          "size-4 text-white md:size-5",
          isTablet ? "min-h-[16px] min-w-[16px]" : "min-h-[20px] min-w-[20px]",
        )}
      />
      <p className="m-0 pr-1 text-xs font-400 leading-[22px] text-white md:text-base">
        {caution}
      </p>
    </div>
  );
}
